import { useState, createContext, useEffect } from 'react'

import { useSelector } from 'react-redux'
import { isFunction } from 'lodash'

import ChatRooms from '../Components/shared/ChatRooms/ChatRooms'
import { selectUser } from '../reducers/UserReducer'
import { isObject } from '../utils'
import { selectTranslate } from '../reducers/LocaleReducer/LocalReducer'
import { addChatRoomToShift, getShiftChatRooms } from '../utils/api/shift'
import { CHAT_ROOM_TYPES, ChatRoom } from '../utils/entities/chatRoom'
import { HttpStatuses } from '../utils/http'

export const ScheduleChatRoomsContext = createContext()

const ScheduleChatRooms = ({ children, onOpen }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [shift, setShift] = useState(null)
  const [chatRooms, setChatRooms] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (shift && isObject(user)) {
      setLoading(true)

      getShiftChatRooms(user, shift).then(({ data }) => {
        setChatRooms(data)
      }).finally(() => {
        setLoading(false)
      })
    } else {
      setChatRooms([])
    }
  }, [user?.id, shift])

  useEffect(() => {
    if (isFunction(onOpen) && shift) {
      onOpen(shift)
    }
  }, [onOpen, shift])

  const handleCreateChatRoom = () => {
    return addChatRoomToShift(user, shift, new ChatRoom({ type: CHAT_ROOM_TYPES.SCHEDULE })).then(({ data }) => {
      return data
    }).catch(error => {
      if (error.status === HttpStatuses.CONFLICT) {
        setShift({ ...shift })
        error = { status: HttpStatuses.CONFLICT, type: 'RELOAD_REQUIRED' }
      } else {
        console.error('Error while creating chat room for shift:', error)
      }

      return Promise.reject(error)
    })
  }

  return (
    <>
      <ScheduleChatRoomsContext.Provider value={{ setShift }}>
        {children}
      </ScheduleChatRoomsContext.Provider>
      {shift && (
        <ChatRooms
          loading={loading}
          chatRooms={chatRooms}
          title={t('schedules_chat_rooms.title')}
          onClose={() => setShift(null)}
          onChatRoomCreate={handleCreateChatRoom}
          onSendMessage
          onUnread
          onFind
        />
      )}
    </>
  )
}

export default ScheduleChatRooms
